"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nonEmptyArrayError = void 0;
const index_1 = require("./index");
__exportStar(require("io-ts"), exports);
__exportStar(require("io-ts-types"), exports);
__exportStar(require("io-ts-reporters"), exports);
const nonEmptyArrayError = (at, expected) => {
    const values = (0, index_1.pipe)(expected, index_1.array.map(index_1.string.doubleQuotes), index_1.monoid.concatAll(index_1.string.join(' | ')));
    return `Expecting NonEmptyArray<(${values})> at ${at} but instead got: []`;
};
exports.nonEmptyArrayError = nonEmptyArrayError;
//# sourceMappingURL=iots.js.map